import { Fragment } from 'react'
import { buildRecoverySteps, recoveryHue, type RecoveryStep } from '../utils/recoveryStepper'
import type { RecoveryDisplayState } from '../services/recoveryCases'

/** The glyph inside a step node — a check, an x, or nothing (a ring). */
function StepGlyph({ icon }: { icon: RecoveryStep['icon'] }) {
  if (icon === 'check') {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path d="M2.5 6.5L5 9L9.5 3.5" stroke="currentColor" strokeWidth="1.8"
          strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
  if (icon === 'x') {
    return (
      <svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path d="M3.5 3.5L8.5 8.5M8.5 3.5L3.5 8.5" stroke="currentColor" strokeWidth="1.8"
          strokeLinecap="round" />
      </svg>
    )
  }
  return null
}

/**
 * The horizontal lifecycle track for one recovery case. Purely presentational —
 * `buildRecoverySteps` owns which stages appear and their tone.
 */
export default function RecoveryStepper({ state }: { state: RecoveryDisplayState }) {
  const steps = buildRecoverySteps(state)
  return (
    <div
      className={`rl-stepper rl-stepper--${recoveryHue(state)}`}
      role="list"
      aria-label="Recovery progress"
    >
      {steps.map((step, i) => (
        <Fragment key={`${step.label}-${i}`}>
          {i > 0 && <div className={`rl-stepper__conn rl-stepper__conn--${step.tone}`} />}
          <div className={`rl-step rl-step--${step.tone}`} role="listitem">
            <span className="rl-step__node">
              <StepGlyph icon={step.icon} />
            </span>
            <span className="rl-step__label">{step.label}</span>
          </div>
        </Fragment>
      ))}
    </div>
  )
}
